import { createSlice } from "@reduxjs/toolkit";

const luckyDrawBannerSlice = createSlice({
  name: "luckyDrawBanner",
  initialState: {
    loading: false,
    saving: false,
    bannerData: [],
    total: 0,
    jewellerBanner: null,
    error: null,
  },

  reducers: {
    saveLuckyDrawBannerRequest: (state) => {
      state.saving = true;
    },

    saveLuckyDrawBannerSuccess: (state) => {
      state.saving = false;
    },

    saveLuckyDrawBannerFailure: (state, action) => {
      state.saving = false;
      state.error = action.payload;
    },

    getLuckyDrawBannersRequest: (state) => {
      state.loading = true;
    },

    getLuckyDrawBannersSuccess: (state, action) => {
      state.loading = false;
      state.bannerData = action?.payload?.data?.data || [];
      state.total = action?.payload?.data?.total || 0;
    },

    getLuckyDrawBannersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    updateLuckyDrawBannerStatusRequest: (state) => {
      state.loading = true;
    },

    updateLuckyDrawBannerStatusSuccess: (state, action) => {
      state.loading = false;
      const updated = action.payload;
      state.bannerData = state.bannerData.map((item) =>
        item._id === updated?._id ? { ...item, status: updated.status } : item,
      );
    },

    updateLuckyDrawBannerStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    getJewellerBannerRequest: () => {},

    getJewellerBannerSuccess: (state, action) => {
      state.jewellerBanner = action?.payload?.data || null;
    },

    getJewellerBannerFailure: (state, action) => {
      state.jewellerBanner = null;
      state.error = action.payload;
    },
  },
});

export const {
  saveLuckyDrawBannerRequest,
  saveLuckyDrawBannerSuccess,
  saveLuckyDrawBannerFailure,
  getLuckyDrawBannersRequest,
  getLuckyDrawBannersSuccess,
  getLuckyDrawBannersFailure,
  updateLuckyDrawBannerStatusRequest,
  updateLuckyDrawBannerStatusSuccess,
  updateLuckyDrawBannerStatusFailure,
  getJewellerBannerRequest,
  getJewellerBannerSuccess,
  getJewellerBannerFailure,
} = luckyDrawBannerSlice.actions;

export default luckyDrawBannerSlice.reducer;
